import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createTheme, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
// Dayjs
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

// Auth
import { AuthProvider } from './auth/AuthContext';

// Mantine
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import mantineTheme from './mantine/mantineTheme';

// Components
import Root from './containers/Root';

dayjs.extend(calendar);
dayjs.extend(relativeTime);
dayjs.extend(utc);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const theme = createTheme(mantineTheme);

function App() {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <MantineProvider theme={theme}>
          <Notifications />
          <div className="font-sans z-10">
            <Root />
          </div>
          {process.env.REACT_APP_NODE_ENV === 'qa' && <ReactQueryDevtools />}
        </MantineProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
